import React from "react";
import { Link } from "react-router-dom";
import { FaFacebookF, FaYoutube, FaTwitter, FaLinkedin, FaWhatsapp,FaInstagram } from "react-icons/fa";
import './Footer.css'
const Footer = () => {
  return (
    <footer className="footer-container">
      <div className="footer-section">
        <h3>HELP LINK</h3>
        <ul >
          <li><Link className="footer-links" to ="/">Home</Link></li>
          <li><Link className="footer-links" to="/about">About</Link></li>
          <li><Link className="footer-links" to="/curriculum">Curriculum</Link></li>
          <li><Link className="footer-links" to="/careers">Careers</Link></li>
          <li><Link className="footer-links" to="/gallery">Gallery</Link></li>
        </ul>
      </div>
      <div className="footer-section follow-us">
        <h3>FOLLOW US</h3>
        <div className="social-icons">
          {/* <FaLinkedin/>
          <FaFacebookF />
          <FaYoutube /> */}
          <a href="https://www.instagram.com/vdprmhighschool?igsh=MTZpNXFnazVkdXRkeA==/" target="_blank" rel="noopener noreferrer">
    <FaInstagram />
  </a>
        </div>
      </div>
      <div className="footer-section contact">
        <h3>V.D. PRASADA RAO
        MEMORIAL HIGH SCHOOL</h3>
        <p>11-13-54/1, Rd Number 1, Alkapuri Colony, SRK Puram, Kothapet, Hyderabad, Telangana 500035.</p>
        <p>Email:vdprmhs1985@gmail.com</p>
        <p>Phone: 040-24034178,96769 47212, 94918 78671</p>
      </div>
    </footer>
  );
};

export default Footer;
